/** Reown AppKit 主题：跟随 Bridge 日/夜（html.dark + --hs-* token） */

const APPKIT_FONT =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

function readSiteCssVar(name, fallback = "") {
  if (typeof document === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

function resolveSiteThemeMode(themeMode) {
  if (themeMode === "light" || themeMode === "dark") return themeMode;
  if (typeof document !== "undefined" && document.documentElement.classList.contains("dark")) {
    return "dark";
  }
  return "light";
}

export function buildAppKitThemeOptions(themeMode) {
  const mode = resolveSiteThemeMode(themeMode);
  const isDark = mode === "dark";
  const accent = readSiteCssVar("--hs-accent", isDark ? "#f0b90b" : "#d4a310");
  const colorMix = readSiteCssVar(
    isDark ? "--hs-surface-main" : "--hs-header-pill-bg",
    isDark ? "#181a20" : "#ffffff",
  );
  const mixStrength = String(isDark ? 92 : 100);
  const radius = readSiteCssVar("--hs-radius-panel", isDark ? "16px" : "12px");
  // AppKit 扫码区背景恒为白色，暗色主题勿用白点否则二维码不可见
  const qrColor = "#141414";
  const themeVariables = {
    "--apkt-accent": accent,
    "--apkt-color-mix": colorMix,
    "--apkt-color-mix-strength": mixStrength,
    "--apkt-border-radius-master": radius,
    "--apkt-font-family": APPKIT_FONT,
    "--apkt-qr-color": qrColor,
    "--apkt-z-index": 2147483646,
    "--w3m-accent": accent,
    "--w3m-color-mix": colorMix,
    "--w3m-color-mix-strength": mixStrength,
    "--w3m-border-radius-master": radius,
    "--w3m-font-family": APPKIT_FONT,
    "--w3m-qr-color": qrColor,
    "--w3m-z-index": 2147483646,
  };
  return { themeMode: mode, themeVariables, enableExplorer: true };
}
